// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { UIModelBaseElement } from './UIModelBaseElement';
import { UIModelComponent } from './UIModelComponent';
import { UIPage } from './UIPage';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 页面分组 实体类
 * 页面分组，页面的地址将使用分组的名称
 */
export class UIPageGroup extends UIModelBaseElement {
  /** 绑定标志 : 绑定元素的标志，使用设计期ID，用于区分自动生成情况下的来源 */
  private _bindingCode: string;

  /** 设置：绑定标志 */
  public get bindingCode() {
    return this._bindingCode;
  }

  /** 获取：绑定标志 */
  public set bindingCode(value: string) {
    this._bindingCode = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: UIModelComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: UIModelComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 页面 */
  private _pages: Array<UIPage>;

  /** 获取：页面 */
  public get pages() {
    return this._pages;
  }

  /** 设置：页面 */
  public set pages(value: Array<UIPage>) {
    this._pages = value;
  }

  constructor() {
    super();
    this._bindingCode = '';
    this._component_ID = '';
    this._component = null;
    this._pages = new Array<UIPage>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UIPageGroup, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.bindingCode = element.bindingCode;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.bindingCode = json.BindingCode;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = UIModelComponent.Create(json.Component);
    // }
    if (json.Pages && json.Pages.length > 0) {
      json.Pages.forEach((element: any) => {
        const uIPage = UIPage.Create(element);
        // uIPage.pageGroup = this;
        this.pages.push(uIPage);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BindingCode = this.bindingCode;
    json.Component_ID = this.component_ID;
    if (this.pages && this.pages.length > 0) {
      json.Pages = [];
      this.pages.forEach((element) => {
        json.Pages.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): UIPageGroup {
    const uIPageGroup = new UIPageGroup();
    uIPageGroup.Deserialize(json);
    uIPageGroup.json = json;
    return uIPageGroup;
  }
}
